<template>
  <div class="page-wrap">
    <div class="session-form-hold">
      <base-card>
        <v-progress-linear
          :active="loading"
          :indeterminate="loading"
          absolute
          top
          color="primary"
        ></v-progress-linear>
        <v-row>
          <v-spacer></v-spacer>
          <v-menu v-model="menu" offset-y :close-on-content-click="false">
            <template v-slot:activator="{ on, attrs }">
              <v-btn class="text-capitalize" v-bind="attrs" v-on="on" text>
                <v-icon left>mdi-translate</v-icon>
                {{ currentLanguageText }}
                <v-icon small right>mdi-menu-down</v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item
                v-for="(lang, index) in languages"
                :key="index"
                @click="changeLanguage(lang.value)"
              >
                <v-list-item-title>{{ lang.text }}</v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu></v-row
        >

        <v-card-text class="text-center">
          <v-avatar size="70" class="mb-2">
            <img src="@/assets/images/optimy-logo.png" alt="" />
          </v-avatar>
          <h2 class="font-weight-bold mb-4">Optimy Pos</h2>
          <h6 class="text--disabled font-weight-medium mb-10">
            {{ $t("signInPage.signin2youacc") }}
          </h6>

          <v-form>
            <v-alert v-model="snackbar" dense color="red lighten-2" dark>
              {{ $t("signInPage.incorrectPassOrEmail") }}
            </v-alert>
            <v-text-field
              :label="$t('signInPage.email')"
              v-model="email"
              :error-messages="emailErrors"
              required
              @input="$v.email.$touch()"
              @blur="$v.email.$touch()"
            />

            <v-text-field
              :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
              :type="show ? 'text' : 'password'"
              name="input-10-2"
              :label="$t('signInPage.password')"
              :counter="10"
              v-model="password"
              @click:append="show = !show"
              :error-messages="passwordErrors"
              required
              @input="$v.password.$touch()"
              @blur="$v.password.$touch()"
            ></v-text-field>
            <v-checkbox
              v-model="checkbox1"
              :label="$t('signInPage.rememberMe')"
            ></v-checkbox>
            <v-btn class="mb-4" @click="login" block color="primary" dark>
              <v-icon left>mdi-login</v-icon>
              {{ $t("signInPage.signIn") }}</v-btn
            >
            <!-- <v-btn
                            class="mb-4"
                            @click="googleSignIn"
                            block
                            color="#DB4437"
                            dark
                        >
                            <v-icon left>
                                mdi-google
                            </v-icon>

                            Sign In
                        </v-btn> -->
            <div class="d-flex justify-center flex-wrap">
              <v-btn
                text
                small
                color="primary"
                to="/app/sessions/sendmail"
                class="mb-2"
                >{{ $t("signInPage.forgotPassword") }}</v-btn
              >
            </div>
            <!-- <div class="d-flex justify-start flex-wrap">
              <v-btn
                text
                small
                class="no-uppercase"
                color="primary"
                to="/app/sessions/signup"
                >New to our POS?</v-btn
              >
            </div> -->
          </v-form>
        </v-card-text>

        <v-snackbar
          v-model="snackbar_alert"
          :timeout="4000"
          color="red lighten-2"
          top
          right
          rounded="pill"
        >
          <v-icon left small>mdi-alert-circle</v-icon>
          {{ snackbar_message }}
          <template v-slot:action="{ attrs }">
            <v-btn text icon v-bind="attrs" @click="snackbar_alert = false">
              <v-icon small>mdi-close</v-icon>
            </v-btn>
          </template>
        </v-snackbar>
      </base-card>
    </div>
  </div>
</template>
<script>
// import firebase from "firebase/app";
// import { mapGetters, mapActions } from "vuex";
import { v4 as uuidv4 } from "uuid";
import { BASEURL } from "@/api/baseurl";
import axios from "axios";
import { validationMixin } from "vuelidate";
import { required, minLength, email } from "vuelidate/lib/validators";
export default {
  name: "login",
  metaInfo: {
    // title will be injected into parent titleTemplate
    title: "Login",
  },

  mixins: [validationMixin],

  validations: {
    email: {
      required,
      email,
    },
    password: { required },
  },
  data() {
    return {
      domain: BASEURL,
      show: false,
      snackbar: false,
      snackbar_alert: false,
      snackbar_message: "",
      checkbox1: true,
      checkbox2: false,
      email: "",
      password: "",
      loading: false,
      menu: false,
      selectedLocale: this.$i18n.locale,
      languages: [
        { text: "English", value: "en" },
        { text: "Chinese", value: "zh-CN" },
        { text: "Bahasa Melayu", value: "ms" },
      ],
    };
  },
  computed: {
    // ...mapGetters(['loggedInUser', 'error'])
    emailErrors() {
      const errors = [];
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push(this.$t("signInPage.validMail"));
      !this.$v.email.required &&
        errors.push(this.$t("signInPage.emailRequire"));
      return errors;
    },
    passwordErrors() {
      const errors = [];
      if (!this.$v.password.$dirty) return errors;
      !this.$v.password.required &&
        errors.push(this.$t("signInPage.passwordRequire"));
      return errors;
    },
    currentLanguageText() {
      const lang = this.languages.find((l) => l.value === this.$i18n.locale);
      return lang ? lang.text : "Select Language";
    },
  },
  methods: {
    changeLanguage(locale) {
      this.selectedLocale = locale; // Update selected locale
      this.$i18n.locale = locale; // Change language in the i18n instance
      localStorage.setItem("locale", locale); // Persist the selected language in local storage
      this.menu = false; // Close the menu after selection
    },

    checkBranchAllowLiveData(companyID) {
      const params = new URLSearchParams();
      params.append("getCompanyBranchWithLiveData", "done");
      params.append("company_id", companyID);
      axios({
        method: "post",
        url: this.domain + "/branch/index.php",
        data: params,
      })
        .then((response) => {
          if (response.data.status == "1") {
            setTimeout(() => {
              this.loading = false;
              this.$router.push("/app/dashboard/report/live-sales");
            }, 500);
          } else {
            setTimeout(() => {
              this.loading = false;
              this.$router.push("/");
            }, 500);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getOrCreateDeviceId() {
      let deviceId = localStorage.getItem("device_id");
      if (!deviceId) {
        deviceId = uuidv4();
        localStorage.setItem("device_id", deviceId);
      }
      return deviceId;
    },

    async getDeviceInfo() {
      const ua = navigator.userAgent;
      return {
        browser: this.getBrowser(ua),
        os: this.getOS(ua),
        ip: await this.getIP(), // async — calls external API
        user_agent: ua,
        language: navigator.language,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        screen: `${screen.width}x${screen.height}`,
      };
    },
    getBrowser(ua) {
      if (ua.includes("Chrome") && !ua.includes("Edg")) return "Chrome";
      if (ua.includes("Firefox")) return "Firefox";
      if (ua.includes("Safari") && !ua.includes("Chrome")) return "Safari";
      if (ua.includes("Edg")) return "Edge";
      if (ua.includes("OPR") || ua.includes("Opera")) return "Opera";
      return "Unknown";
    },

    getOS(ua) {
      if (ua.includes("Windows NT 10.0")) return "Windows 10/11";
      if (ua.includes("Windows")) return "Windows";
      if (ua.includes("Mac OS X")) return "macOS";
      if (ua.includes("Android")) return "Android";
      if (ua.includes("iPhone")) return "iOS";
      if (ua.includes("Linux")) return "Linux";
      return "Unknown";
    },

    async getIP() {
      try {
        const res = await fetch("https://api.ipify.org?format=json");
        const data = await res.json();
        return data.ip;
      } catch {
        return null;
      }
    },

    async login() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;

        // ✅ Collect device info before login
        const deviceId = this.getOrCreateDeviceId();
        const deviceInfo = await this.getDeviceInfo();

        const params = new URLSearchParams();
        params.append("loginNewAPI", "done");
        params.append("email", this.email);
        params.append("password", this.password);
        params.append("device_id", deviceId);
        params.append("device_info", JSON.stringify(deviceInfo));
        params.append("remember_me", this.checkbox1 ? "1" : "0"); // checkbox1 = Remember Me

        axios({
          method: "post",
          url: this.domain + "/user/index.php",
          data: params,
        })
          .then((response) => {
            if (response.data.status == "1") {
              var CryptoJS = require("crypto-js");
              var ciphertext = CryptoJS.AES.encrypt(
                JSON.stringify(response.data.user),
                "secret key 123"
              ).toString();

              localStorage.setItem("userInfo", ciphertext);

              const token = response.data.token;
              if (this.checkbox1) {
                localStorage.setItem("session_token", token);
              } else {
                sessionStorage.setItem("session_token", token);
              }

              // ✅ Start polling after successful login
              this.$store.dispatch("startSessionPolling");

              this.checkBranchAllowLiveData(response.data.user.company_id);
            } else {
              this.snackbar = true;
              this.loading = false;
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    // async login() {
    //   this.$v.$touch();
    //   if (!this.$v.$invalid) {
    //     this.loading = true;
    //     const params = new URLSearchParams();
    //     params.append("login", "done");
    //     params.append("email", this.email);
    //     params.append("password", this.password);

    //     axios({
    //       method: "post",
    //       url: this.domain + "/user/index.php",
    //       data: params,
    //     })
    //       .then((response) => {
    //         if (response.data.status == "1") {
    //           var CryptoJS = require("crypto-js");

    //           // Encrypt
    //           var ciphertext = CryptoJS.AES.encrypt(
    //             JSON.stringify(response.data.user),
    //             "secret key 123"
    //           ).toString();

    //           localStorage.setItem("userInfo", ciphertext);

    //           this.checkBranchAllowLiveData(response.data.user.company_id);
    //         } else {
    //           this.snackbar = true;
    //           this.loading = false;
    //         }
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //   }
    // },
  },
  watch: {},

  mounted() {
    if (this.$route.query.reason === "session_terminated") {
      this.snackbar_message =
        "Your session was terminated. Please log in again.";
      this.snackbar_alert = true;
    }
  },
};
</script>
<style lang="scss" scoped>
.page-wrap {
  background-image: linear-gradient(to bottom, transparent, #837960),
    url("../../../assets/images/login-background.jpg");
  background-color: #242939 !important;
  background-size: cover;
  display: flex;
  align-items: center;
  padding: 40px 1rem;
  height: 100%;
  min-height: 100vh;
}
.session-form-hold {
  width: 100%;
  max-width: 400px;
  margin: 0 auto;
}
.no-uppercase {
  text-transform: unset !important;
}
.v-menu__activator {
  cursor: pointer;
}
</style>
